import React from "react";
import { Route, Redirect } from "react-router-dom";

const InternalRoute = ({
  component: Component,
  redirect,
  isAuthenticated,
  ...rest
}) => (
  <Route
    {...rest}
    render={props =>
      isAuthenticated ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: redirect,
            state: { from: props.location }
          }}
        />
      )
    }
  />
);

export default InternalRoute;
